module.exports = __webpack_public_path__ + "static/media/md-cut.126dd542.svg";